import { createReducer } from '@reduxjs/toolkit';

const initialState = false;

/**
 * Keeps simulation mode state
 *
 * @param  {Array} state: the new state
 * @param  {Object} action: action to be performed
 * @return {Object} the new state
 */
const inSimulationMode = createReducer(initialState, {
  SET_SIMULATION_MODE: (state, { value }) => value.payload,
});

export default inSimulationMode;
